import { render, staticRenderFns } from "./quality-main.vue?vue&type=template&id=b1cc9b84"
import script from "./quality-main.vue?vue&type=script&lang=js"
export * from "./quality-main.vue?vue&type=script&lang=js"
import style0 from "./quality-main.vue?vue&type=style&index=0&id=b1cc9b84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports